module.exports = __webpack_public_path__ + "static/media/iconfont.63cd98f0.woff";